<template>
    <div class="form-group">
        <label>Yleisömäärä</label>
        <multiselect
            @select="onSelect"
            :options="crowdOptions"
            :searchable="true"
            track-by="id"
            label="name"
            :options-limit="10"
            :allow-empty="false"
            placeholder="Valitse"
            selectLabel=""
            deselectLabel=""
            selectedLabel=""
            :show-no-results="false"
            :hide-selected="false"
            :value="selectedCrowd">
            <span slot="noResult"></span>
        </multiselect>
    </div>
</template>

<script>
    import Multiselect from 'vue-multiselect';

    export default {
        model: {
            prop: 'selectedCrowd',
            event: 'change'
        },
        components: {
            Multiselect
        },
        props: {
            crowdOptions: {
                type: Array
            },
            selectedCrowd: {
                type: Object,
                required: false
            }
        },
        methods: {
            onSelect(crowd) {
                this.$emit('change', crowd);
            }
        }
    };
</script>
